import { CARGO_STAGES } from "src/app/Cargo/types";
import type { LobKey } from "./preScreen/types";

// Re-export for consumers that import from this module
export { CARGO_STAGES };

/**
 * Route paths for JSON Forms pages.
 *
 * Use `buildLobClaimIntakePath(lob)` instead of constructing
 * `/json-forms/<lob>/claim-intake-form` strings inline so the URL shape
 * is centralized.
 */
export const JSON_FORMS_ROUTES = {
  LOB_SELECTOR: "/json-forms",
  /**
   * Parameterized route registered with React Router. The `:lob` segment
   * is read by `JsonFormsClaimIntakeApp` via `useParams<{ lob }>()`.
   */
  LOB_CLAIM_INTAKE_TEMPLATE: "/json-forms/:lob/claim-intake-form",
  CARGO_CLAIM_INTAKE_FORM: "/json-forms/cargo/claim-intake-form",
  CARGO_CONTINUE_FORM: "/json-forms/cargo/claim-intake-form/continue",
  WC_CLAIM_INTAKE_FORM: "/json-forms/wc/claim-intake-form",
  IPL_CLAIM_INTAKE_FORM: "/json-forms/ipl/claim-intake-form",
} as const;

/**
 * Build the absolute path to a given LOB's claim-intake form. Used by
 * the LOB selector and the orchestrator's single-LOB redirect to keep
 * the URL shape in lockstep with `LOB_CLAIM_INTAKE_TEMPLATE`.
 */
export function buildLobClaimIntakePath(lob: LobKey): string {
  return `/json-forms/${lob}/claim-intake-form`;
}

/**
 * Form data keys for Cargo stages in the jsonFormsSlice.
 * Used to key form data and validation errors by `{lob}_{stage}`.
 */
export const CARGO_STAGE_KEYS = {
  STAGE1: "cargo_stage1",
  STAGE2: "cargo_stage2",
  STAGE3: "cargo_stage3",
} as const;

/**
 * Maps a submitted stage to the next stage key for form loading.
 * When a claim has `submittedStage: STAGE1`, the user should continue with Stage 2, etc.
 */
export const NEXT_STAGE_MAP: Record<string, string> = {
  [CARGO_STAGES.STAGE1]: CARGO_STAGE_KEYS.STAGE2,
  [CARGO_STAGES.STAGE2]: CARGO_STAGE_KEYS.STAGE3,
} as const;
